import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloFeedDownload extends AloBase {    
    newId:number
    flxId:number
    ptnId:number
    dldDisabled:boolean
    dldLogin:string
    dldPass:string
    dldPathfile:string
    dldFinalName:string
    dldNote:string
    dldJsonParam:string
    dldDatload:string    
}

export const getDefaultAloFeedDownload = ():AloFeedDownload => {
    return {
        ...getDefaultAloBase(),
        newId:0,
        flxId:0,
        ptnId:0,
        dldDisabled:false,        
        dldLogin:'',
        dldPass:'',
        dldPathfile:'',
        dldFinalName:'',
        dldNote:'',
        dldJsonParam:'{}',
        dldDatload:''
    }
}

export const cleanAloFeedDownload = (feedDownload:AloFeedDownload) => {
    if(!feedDownload) return    
    if(!feedDownload.id) delete feedDownload.id
    if(!feedDownload.flxId) delete feedDownload.flxId
    if(!feedDownload.ptnId) delete feedDownload.ptnId
}
